module.exports = __webpack_public_path__ + "media/images/steps_active_left_flat-414534a206b86d3f96ad0dd1506240da.png";